import React from 'react';
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: 'primary' | 'secondary' | 'violet';
  size?: 'md' | 'lg';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'lg',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-sm transition-all duration-300 transform hover:scale-105 text-center uppercase tracking-widest border';
  const variants = {
    primary: 'border-gold/50 bg-gradient-to-r from-gold-dark via-gold to-gold-dark hover:from-gold hover:via-gold-light hover:to-gold text-mystic-900 shadow-[0_0_20px_rgba(202,162,74,0.4)] hover:shadow-[0_0_30px_rgba(202,162,74,0.6)]',
    secondary: 'bg-mystic-800/80 border-gold/50 text-gold hover:bg-mystic-700 hover:border-gold shadow-[0_0_15px_rgba(109,74,156,0.3)]',
    violet: 'border-gold/60 bg-gradient-to-r from-violet-dark via-violet-accent to-violet-dark hover:from-violet-accent hover:via-violet-light hover:to-violet-accent text-white shadow-[0_0_22px_rgba(109,74,156,0.55)] hover:shadow-[0_0_34px_rgba(138,95,196,0.7)]'
  };
  const sizes = {
    md: 'px-6 py-3 text-sm md:text-base',
    lg: 'px-8 py-4 text-base md:text-lg w-full md:w-auto'
  };
  return <a className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-275">
      {children}
    </a>;
}